module.exports = __webpack_public_path__ + "img/delete.475f9da9.svg";